import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, UntypedFormGroup, Validators } from '@angular/forms';
import { atLeastOneJourneyFieldRequired } from '../validators/journey-validators';
import { JourneyUiJourneyScope, initialJourneyUiJourneyScope } from '../../model';
import { UppComponentNames } from '../../../service/model/upp-component';
import { journeyTypesGroupValueFn, journeyTypesOptions } from '../../../model/common-elements';
import { LookupSelectComponent } from '../../../components/lookup-select/lookup-select.component';
import { ValidationErrorMessageComponent } from '../../../components/validation-error-message/validation-error-message.component';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { JOURNEY_TYPE_VALIDATION_MESSAGES } from '../../../service/model/common/validation-messages';

@Component({
  selector: 'ama-ng-upp-journey-content',
  templateUrl: './journey-content.component.html',
  standalone: true,
  imports: [ReactiveFormsModule, LookupSelectComponent, ValidationErrorMessageComponent, NgbTooltip]
})
export class JourneyContentComponent implements OnInit {
  @Input() journeyFormGroup!: UntypedFormGroup;
  @Input() journeyScope?: JourneyUiJourneyScope = initialJourneyUiJourneyScope;
  @Input() readonly = false;
  @Input() excludeIntracityConnectionsEnabled: boolean | null = null;

  UppComponentNames = UppComponentNames;

  journeyTypesOptions = journeyTypesOptions;
  journeyTypesGroupValueFn = journeyTypesGroupValueFn;
  journeyTypeValidationMessages = JOURNEY_TYPE_VALIDATION_MESSAGES;

  constructor(private readonly formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.journeyFormGroup?.setControl(
      'flightCategories',
      this.formBuilder.control(
        {
          value: this.journeyScope?.flightCategories,
          disabled: this.readonly
        },
        this.excludeIntracityConnectionsEnabled ? [] : [Validators.required]
      )
    );

    if (this.excludeIntracityConnectionsEnabled) {
      this.journeyFormGroup?.setControl(
        'intracity',
        this.formBuilder.control({
          value: this.journeyScope?.intracity ?? false,
          disabled: this.readonly
        })
      );

      this.journeyFormGroup?.setValidators(atLeastOneJourneyFieldRequired);
      this.journeyFormGroup?.updateValueAndValidity();
    }
  }

  /**
   * flightCategories and intracity are validated together (at least one is required), so touching
   * either one should highlight both
   */
  onJourneyFieldTouched(): void {
    const intracity = this.journeyFormGroup?.get('intracity');
    if (!intracity) {
      return;
    }

    this.journeyFormGroup?.get('flightCategories')?.markAsTouched({ onlySelf: true });
    intracity.markAsTouched({ onlySelf: true });
  }
}
